import { Outlet } from "react-router-dom";
import { ROLE } from "../../../data/enums";
import { useContext } from "react";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
    NotFoundBox,
    NotFoundContainer,
    NotFoundTitle,
    NotFoundHeading,
    NotFoundDescription,
    NotFoundButton
} from "./Styled";

const ProtectedRoute = ({ allowedRoles }: { allowedRoles: ROLE[] }) => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const navigate = useNavigate();

    if (!allowedRoles.includes(role)) {
        return (
            <NotFoundBox>
                <NotFoundContainer maxWidth="md">
                    <NotFoundTitle variant="h1">
                        404
                    </NotFoundTitle>
                    <NotFoundHeading variant="h4">
                        Không tìm thấy trang
                    </NotFoundHeading>
                    <NotFoundDescription variant="body1">
                        Trang bạn đang tìm kiếm không tồn tại.
                    </NotFoundDescription>
                    <NotFoundButton
                        variant="contained"
                        onClick={() => navigate('/')}
                    >
                        Quay lại trang chủ
                    </NotFoundButton>
                </NotFoundContainer>
            </NotFoundBox>
        );
    }

    return <Outlet />;
};

export default ProtectedRoute;
